import * as React from "react";
import {ISymptom} from "@curefit/care-common";
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"

/**
 * Created by abhinav on 28/01/18.
 */

let SymptomEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "name", display: "Symptoms"},
    {label: "days", display: "No. of Days"},
    {label: "attributes", display: "Attributes (if any)"}
];


export interface PatientSymptomEditorProps {
    customHeaders?: ICustomHeaderInfo[],
    updatedSymptoms: {item: ISymptom}[],
    updateSymptoms: (updatedSymptoms: {item: ISymptom}[]) => void
}

class PatientSymptomEditor extends React.Component<PatientSymptomEditorProps> {

    constructor(props: PatientSymptomEditorProps) {
        super(props);
    }

    onSymptomRemove = (index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedSymptoms);
        currUpdatedSymptoms.splice(index, 1);
        this.props.updateSymptoms(currUpdatedSymptoms);
    }

    onSymptomChange = (updatedSymptom: ISymptom, index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedSymptoms);
        currUpdatedSymptoms[index] = updatedSymptom;
        this.props.updateSymptoms(currUpdatedSymptoms);
    }

    render() {
        let customHeader = this.props.customHeaders !== undefined ? this.props.customHeaders : SymptomEditorHeaderInfos;
        return (
            <div className="patient-symptom-editor">
                <CustomHeader headerInfos={customHeader} rootCls={"patient-symptom"}/>
                <TemplatedList templateName={"symptom"} commonProps={{}}
                               defaultItem={{item: ModelFactory.createNewSymptom()}}
                               listItems={this.props.updatedSymptoms}
                               onItemRemove={this.onSymptomRemove}
                               onItemChange={this.onSymptomChange}/>
            </div>
        );
    }
}

export default PatientSymptomEditor